/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ScrollBoundaryComponent as ScrollBoundary } from './ScrollBoundary.component';
